import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import Divider from '@src/common/components/Divider';
import Style from './index.css';
import { getModuleByName, getTabByName, getThumbnailFromRecommend } from '@src/common/utils';
import { formatImage } from '@ifeng/public_method';

const Tabs = props => {
    const { content } = props;
    const tabData = getModuleByName(content, '现场花絮').data.articleList;
    const [current, setCurrent] = useState('第一期');
    const [contentList, setContentList] = useState([]);

    useEffect(() => {
        const defaultValue = getTabByName(tabData, '第一期');

        setContentList(defaultValue);
    }, []);

    const handleTabChange = tab => {
        const module = getTabByName(tabData, tab);

        if (module && module.source !== 'hide') {
            setCurrent(tab);
            setContentList(module);
        }
    };

    return (
        <div>
            <div className={Style.tabs}>
                <Divider />
                <div className={Style.tabsTitleList}>
                    <div className={`${Style.tabTitle} ${current === '第一期' ? Style.active : ''}`}>
                        <div onMouseEnter={() => handleTabChange('第一期')}>第一期</div>
                    </div>
                    <div className={`${Style.tabTitle} ${current === '第二期' ? Style.active : ''}`}>
                        <div onMouseEnter={() => handleTabChange('第二期')}>第二期</div>
                    </div>
                    <div className={`${Style.tabTitle} ${current === '第三期' ? Style.active : ''}`}>
                        <div onMouseEnter={() => handleTabChange('第三期')}>第三期</div>
                    </div>
                    <div className={`${Style.tabTitle} ${current === '第四期' ? Style.active : ''}`}>
                        <div onMouseEnter={() => handleTabChange('第四期')}>第四期</div>
                    </div>
                </div>
                <Divider />

                <div className={Style.content}>
                    <div className={Style.left}>
                        <a href={contentList?.url} target="_blank" rel="noreferrer">
                            <img src={formatImage(contentList?.thumbnails?.image?.[0]?.url, 337, 324)} />
                        </a>
                    </div>
                    <div className={Style.right}>
                        {contentList?.thumbnails?.image?.slice(1, 7).map((item, index) => {
                            return (
                                <a href={contentList?.url} target="_blank" key={index} rel="noreferrer">
                                    <img src={formatImage(item?.url, 198, 150)} alt="" />
                                </a>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

Tabs.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Tabs);
